import http from 'axios'

export const uploadFile = ({ id, file }) => {
  const formData = new FormData()
  formData.append('file', file)

  return {
    type: 'FILES/UPLOAD',
    payload: http({
      method: 'POST',
      url: 'api/v1/numbers/erou',
      data: formData,
    }),
    meta: {
      id,
    },
  }
}

export const uploadAudio = ({ id, file }) => {
  const formData = new FormData()
  formData.append('file', file)

  return {
    type: 'FILES/UPLOAD',
    payload: http({
      method: 'POST',
      url: 'api/v1/twilio/media',
      data: formData,
    }),
    meta: {
      id,
    },
  }
}

export const uploadAudioForPorta = ({ id, file }) => {
  const formData = new FormData()
  formData.append('file', file)

  return {
    type: 'FILES/UPLOAD',
    payload: http({
      method: 'POST',
      url: 'api/v1/flows/audio',
      data: formData,
    }),
    meta: {
      id,
    },
  }
}

export const uploadTwilioDocument = ({ id, file }) => {
  const formData = new FormData()
  formData.append('file', file)

  return {
    type: 'FILES/UPLOAD',
    payload: http({
      method: 'POST',
      url: 'api/v1/twilio/documents',
      data: formData,
    }),
    meta: {
      id,
    },
  }
}

export const uploadMobileServiceDocument = ({ id, file }) => {
  const formData = new FormData()
  formData.append('file', file)

  return {
    type: 'FILES/UPLOAD',
    payload: http({
      method: 'POST',
      url: 'api/v1/mobile-services/documents',
      data: formData,
    }),
    meta: {
      id,
    },
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/Files.actions.js